import axios from "../../../../services/api";
import Axios, { AxiosResponse, CancelTokenSource } from "axios";
import { PaginationParamProps } from "../../../hooks";
import { getEnv } from "../../../../api";

interface IAcessosService {
  findAll: (
    params: PaginationParamProps,
    body: Record<string, any>,
    source?: { token: CancelTokenSource }
  ) => Promise<any>;

  getOptions: () => Promise<any>;
}

export const AcessosService: IAcessosService = {
  findAll: async (params, body = {}, source) => {
    try {
      // @ts-ignore
      const response: AxiosResponse = await axios.post(
        `${await getEnv("REACT_APP_URL_SERVICE")}/v1/acessos`,
        body,
        {
          params,
        }
      );
      return response.data;
    } catch (error: any) {
      if (Axios.isCancel(error)) {
        console.log("Requisição cancelada", error.message);
      } else {
        console.log(error.message);
        throw error;
      }
    }
  },

  getOptions: async () => {
    try {
      // @ts-ignore
      const response = await axios.get(
        `${await getEnv(
          "REACT_APP_URL_SERVICE"
        )}/v1/acessos/opcoes?consulta=true`
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },
};
